<template>
  <div class="container">
    <div class="square p1"></div>
    <div class="square p2"></div>
    <div class="square p3"></div>
    <div class="square p4"></div>
    <span v-for="(price, index) in prices" :class="`label-score l${price.rank}`" :key="index">
      <template v-if="price.type === 'score'">
        {{ price.score }}
      </template>
      <template v-else>
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_1_312)">
            <path
              d="M16.8615 5.82906H15.0642C15.1549 5.57348 15.2126 5.29316 15.2126 5.00461C15.2126 3.63602 14.1078 2.53125 12.7392 2.53125C11.8736 2.53125 11.1233 2.97645 10.6781 3.64426L10.2659 4.19664L9.85366 3.63602C9.40845 2.97645 8.6582 2.53125 7.79253 2.53125C6.42394 2.53125 5.31917 3.63602 5.31917 5.00461C5.31917 5.29316 5.37688 5.57348 5.46757 5.82906H3.67027C2.75512 5.82906 2.02961 6.56282 2.02961 7.47796L2.02136 16.5469C2.02136 17.4621 2.75512 18.1958 3.67027 18.1958H16.8615C17.7766 18.1958 18.5104 17.4621 18.5104 16.5469V7.47796C18.5104 6.56282 17.7766 5.82906 16.8615 5.82906ZM12.7392 4.18015C13.1927 4.18015 13.5637 4.55116 13.5637 5.00461C13.5637 5.45806 13.1927 5.82906 12.7392 5.82906C12.2858 5.82906 11.9148 5.45806 11.9148 5.00461C11.9148 4.55116 12.2858 4.18015 12.7392 4.18015ZM7.79253 4.18015C8.24598 4.18015 8.61698 4.55116 8.61698 5.00461C8.61698 5.45806 8.24598 5.82906 7.79253 5.82906C7.33908 5.82906 6.96807 5.45806 6.96807 5.00461C6.96807 4.55116 7.33908 4.18015 7.79253 4.18015ZM16.8615 16.5469H3.67027V14.898H16.8615V16.5469ZM16.8615 12.4247H3.67027V7.47796H7.85848L6.14362 9.81116L7.47924 10.7758L9.44143 8.10455L10.2659 6.98329L11.0903 8.10455L13.0525 10.7758L14.3881 9.81116L12.6733 7.47796H16.8615V12.4247Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1_312">
              <rect width="19.7869" height="19.7869" fill="white" transform="translate(0.372437 0.882324)" />
            </clipPath>
          </defs>
        </svg>
      </template>
    </span>
  </div>
</template>

<script>
export default {
  name: 'WheelPreview',
  props: {
    prices: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.container {
  width: 300px;
  height: 300px;
  min-width: 300px;
  min-height: 300px;
  display: grid;
  place-items: center;
  grid-template-columns: repeat(2, 1fr);
  border-radius: 50%;
  overflow: hidden;
  position: relative;
}
.square {
  box-sizing: border-box;
  width: 150px;
  height: 150px;
  border-width: 75px;
  position: relative;
}
.p1 {
  border-color: #7a7a7a #7a7a7a #b2b2b2 #b2b2b2;
}
.p2 {
  border-color: #b2b2b2 #7a7a7a #7a7a7a #b2b2b2;
}
.p3 {
  border-color: #7a7a7a #b2b2b2 #b2b2b2 #7a7a7a;
}
.p4 {
  border-color: #b2b2b2 #b2b2b2 #7a7a7a #7a7a7a;
}
.label-score {
  position: absolute;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  transform: translate(-50%, -50%);
}
.l0 {
  top: 70px;
  left: 185px;
}
.l1 {
  top: 119px;
  left: 238px;
}
.l2 {
  top: 185px;
  left: 238px;
}
.l3 {
  top: 238px;
  left: 186px;
}
.l4 {
  top: 238px;
  left: 115px;
}
.l5 {
  top: 180px;
  left: 62px;
}
.l6 {
  top: 119px;
  left: 62px;
}
.l7 {
  top: 70px;
  left: 115px;
}
</style>



// WEBPACK FOOTER //
// src/components/wheels/ui/wheel-preview.vue